import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";
import "./marketing.css";

const AutomationPage = lazy(() => import("./automations").then((m) => ({ default: m.AutomationPage })));
const AutomationsPage = lazy(() => import("./automations").then((m) => ({ default: m.AutomationsPage })));
const CampaignPage = lazy(() => import("./campaigns").then((m) => ({ default: m.CampaignPage })));
const CampaignsPage = lazy(() => import("./campaigns").then((m) => ({ default: m.CampaignsPage })));
const EmailLogPage = lazy(() => import("./emails").then((m) => ({ default: m.EmailLogPage })));
const MarketingPage = lazy(() => import("./overview").then((m) => ({ default: m.MarketingPage })));
const MarketingSettings = lazy(() => import("./settings").then((m) => ({ default: m.MarketingSettings })));
const SubscriberPage = lazy(() => import("./subscribers").then((m) => ({ default: m.SubscriberPage })));
const SubscribersPage = lazy(() => import("./subscribers").then((m) => ({ default: m.SubscribersPage })));
const EmailTemplatePage = lazy(() => import("./templates").then((m) => ({ default: m.EmailTemplatePage })));
const EmailTemplatesPage = lazy(() => import("./templates").then((m) => ({ default: m.EmailTemplatesPage })));

/** Marketing: email to members who said yes. Campaigns, templates, automations, subscribers and the email log. */

export const routes: SolutionRoute[] = [
  { solution: "marketing", path: "marketing", element: <MarketingPage /> },
  { solution: "marketing", path: "marketing/campaigns", element: <CampaignsPage /> },
  { solution: "marketing", path: "marketing/campaigns/templates", element: <EmailTemplatesPage /> },
  { solution: "marketing", path: "marketing/campaigns/templates/:id", element: <EmailTemplatePage /> },
  { solution: "marketing", path: "marketing/campaigns/:id", element: <CampaignPage /> },
  { solution: "marketing", path: "marketing/automations", element: <AutomationsPage /> },
  { solution: "marketing", path: "marketing/automations/:key", element: <AutomationPage /> },
  { solution: "marketing", path: "marketing/subscribers", element: <SubscribersPage /> },
  { solution: "marketing", path: "marketing/subscribers/:id", element: <SubscriberPage /> },
  { solution: "marketing", path: "marketing/emails", element: <EmailLogPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "marketing", key: "marketing", label: "Marketing", icon: Icon.mail, need: "marketing.view", Component: MarketingSettings }];

export const nav: NavItem = {
  to: "/marketing",
  label: "Marketing",
  icon: Icon.mail,
  solution: "marketing",
  need: "marketing.view",
  subs: [
    { to: "/marketing/campaigns", label: "Campaigns" },
    { to: "/marketing/automations", label: "Automations" },
    { to: "/marketing/subscribers", label: "Subscribers" },
    { to: "/marketing/emails", label: "Email log" },
  ],
};
